import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#ff9800",
    },
    error: {
      main: "#ad0000",
    },
  },
  typography: {
    fontFamily: "Gotham Medium",
    fontWeight: "normal",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: "auto",
          borderRadius: "0px",
          fontSize: "16px",
          borderWidth: "10px",
          fontFamily: "Gotham Medium",
          fontWeight: "normal",
        },
        outlined: {
          padding: "15px 25px",
        },
        contained: {
          padding: "7px 16px",
        },
        sizeSmall: {
          padding: "5px 10px",
          height: "30px",
        },
        containedPrimary: {
          color: "#ff9800",
          padding: "10px 25px",
          fontFamily: "Gotham Medium",

          "&:hover": {
            backgroundColor: "#e5e4e2",
          },
        },
        containedSecondary: {
          color: "#ffffff",
          backgroundColor: "#ff9800",
          padding: "10px 25px",
          fontFamily: "Gotham Medium",
        },
        outlinedPrimary: {
          border: "1px solid #ffffff",
          transition: "all 200ms ease-in-out",
          "&:hover": {
            border: "1px solid #ffffff",
            backgroundColor: "#ffffff",
            color: "#ff9800",
          },
        },
        outlinedSecondary: {
          border: "2px solid #ff9800",
          transition: "all 200ms ease-in-out",
          color: "#ff9800",
          textDecoration: "none",
          "&:hover": {
            backgroundColor: "#ff9800",
            color: "#ffffff",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: "0",
          borderRadius: "18px",
          width: "53px",
          height: "24px",
        },
        thumb: {
          width: "18px",
          height: "18px",
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.15)",
          ".Mui-checked.MuiSwitch-colorSecondary &": {
            transform: "translateX(7px)",
          },
          ".Mui-checked.MuiSwitch-colorPrimary &": {
            transform: "translateX(9px) !important",
          },
        },
        track: {
          backgroundColor: "#ffcc00",
          ".Mui-checked.MuiSwitch-colorSecondary + &": {
            backgroundColor: "#00ccff",
          },
          ".Mui-checked.MuiSwitch-colorPrimary + &": {
            backgroundColor: "#ff9800 !important",
            opacity: 1,
          },
        },

        switchBase: {
          padding: "3px",
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
        },
        fontSizeLarge: {
          fontSize: "40px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: "0px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "AvertaRegular",
          fontWeight: "normal",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        button: {
          color: "#ff9800",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&$focused": {
            color: "#ff9800",
          },
          color: "#ff9800",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "white",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&$focused $notchedOutline": {
            borderColor: "#ff9800",
            borderWidth: "2px",
          },
          "&:hover $notchedOutline": {
            borderColor: "#ff9800",
            borderWidth: "2px",
          },
          borderRadius: "0",
        },
        notchedOutline: {
          borderColor: "#ff9800",
          borderWidth: "2px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#ff9800",
        },
      },
    },
  },
});
export default theme;
